import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { faBookReader } from '@fortawesome/pro-solid-svg-icons';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { loadMoreSingleShowcase } from 'search/full-card/actions/showcases.actions';
import { CommonState } from 'search/full-card/models/card-header';
import {
  CustomShowcaseMetadataInfo,
  ExtractedMultipleShowcase,
  ExtractedSingleShowcaseResource,
  ShowcasesEntity,
  ShowcasesTypes,
} from 'search/full-card/models/showcases';
import { selectSingleShowcase } from 'search/full-card/reducers/showcases.reducer';
import { ShowcaseHelperService } from 'search/full-card/services/showcase-helper.service';
import { getIsFirstPage } from 'search/reducers/history.reducer';
import { EntityTypes } from '../../../../../../entity/models/entity';

@Component({
  selector: 'app-see-all-page',
  templateUrl: './see-all-page.component.html',
  styleUrls: ['./see-all-page.component.scss'],
})
export class SeeAllPageComponent implements OnInit, OnDestroy {
  @Input() public entity: ShowcasesEntity;
  @Input() public showcaseType: ShowcasesTypes;
  @Input() public isMultipleView: boolean;
  @Output() public scrollToContent: EventEmitter<void> = new EventEmitter();
  public subscriptions = new Subscription();
  public hasPreviousUrl: boolean;
  public isLoadMore: boolean;
  public isLoading: boolean;
  public totalCount: number;
  public showcaseItems: (ExtractedSingleShowcaseResource | ExtractedMultipleShowcase | any)[];
  public showcaseMetadata: CustomShowcaseMetadataInfo;
  public identifier: string;
  public showcaseId: string;
  public name: string;
  public pageNum = 1;
  public isAutoGeneratedShowcase: boolean;
  public showcasesTypes = ShowcasesTypes;
  public entityTypes = EntityTypes;
  public readonly customShowcaseIcon = faBookReader;

  constructor(
    public store: Store<CommonState>,
    public location: Location,
    public elementRef: ElementRef,
    public cdRef: ChangeDetectorRef,
    private readonly showcaseHelper: ShowcaseHelperService,
  ) {
  }

  public ngOnInit() {
    this.subscriptions.add(this.store.pipe(select(getIsFirstPage)).subscribe((isFirstPage: boolean) => {
      this.hasPreviousUrl = !isFirstPage;
    }));
    this.subscriptions.add(this.store.pipe(select(selectSingleShowcase, {showcase: this.showcaseType})).subscribe((showcase: any) => {
      this.showcaseItems = this.showcaseHelper.extractShowcaseData(this.showcaseType, showcase, this.isMultipleView).data;
      if (this.showcaseType === ShowcasesTypes.CUSTOM) {
        this.showcaseMetadata = showcase.metadata;
      }
      this.isLoading = showcase.loading;
      this.totalCount = showcase.totalCount;
      this.isLoadMore = this.showcaseItems && this.totalCount > this.showcaseItems.length;
      this.identifier = !this.isMultipleView ? showcase.identifier : this.showcaseType;
      this.showcaseId = showcase.showcaseId;
      this.name = showcase.name;
      this.isAutoGeneratedShowcase = ![
        ShowcasesTypes.RESOURCES,
        ShowcasesTypes.CONTRIBUTORS,
        ShowcasesTypes.TOPICS,
        ShowcasesTypes.CUSTOM,
      ].some((type) => this.showcaseType === type);
      this.cdRef.markForCheck();
    }));
  }

  public loadMore(isMouseClick: boolean) {
    this.store.dispatch(loadMoreSingleShowcase({
      id: this.entity.id,
      entityType: this.entity.entityType,
      showcaseId: this.showcaseId,
      showcase: this.showcaseType,
      identifier: this.identifier,
      isMouseClick,
    }));
  }

  public setFocusOnBackButton() {
    const selector = '[data-focus-id=back-button]';
    setTimeout(() => (this.elementRef.nativeElement.querySelector(selector) as HTMLElement).focus(), 100);
  }

  public onScrollToContent() {
    this.scrollToContent.emit();
  }

  public goToPreviousPage() {
    this.location.back();
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
